module.exports = __webpack_public_path__ + "static/media/uWaterloo.f23bb8f7.png";